import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { Paper } from '../Paper';
import { placeholderStyles } from './Placeholder.styles';
import { placeholderTheme } from './Placeholder.stylex';
import { commonStyles } from '../../helpers/commonStyles';
import { sizeToString } from '../../helpers/sizeToString';
export const Placeholder = forwardRef(function Placeholder(props, forwardedRef) {
    const { innerStyles, styles, sx, surface = 'surfaceContainerHighest', corner = 'sm', label, children, crosshairs, disabled, width, height, ...other } = props;
    const { combineStyles, getStyles, globalStyles } = useStyles({
        name: 'Placeholder',
        styles: [placeholderStyles, styles],
    });
    const widthAsString = width !== undefined ? sizeToString(width) : undefined;
    const heightAsString = height !== undefined ? sizeToString(height) : undefined;
    return (_jsxs(Paper, { innerStyles: innerStyles, ...other, surface: surface, corner: corner, sx: [
            placeholderTheme,
            globalStyles,
            combineStyles('host', widthAsString !== undefined && commonStyles.width(widthAsString), heightAsString !== undefined && commonStyles.height(heightAsString), disabled ? 'host$disabled' : null),
            sx,
        ], ref: forwardedRef, children: [crosshairs ? _jsx("div", { ...getStyles('crosshairs') }) : null, label ? _jsx("div", { ...getStyles('label'), children: label }) : null, children] }));
});
